module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/6chap1#chap1"
    }
  }, [_vm._v("INTRODUCTION by Terry Bisson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/7chap2#chap2"
    }
  }, [_vm._v("THE WAR OF THE WORLDVIEWS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/8chap3#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WISDOM OF THE SKIN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARTYRS OF THE UPSHOT KNOTHOLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COME BACK, DR. SARCOPHAGUS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE FATE OF NATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE EYE THAT NEVER BLINKS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DIRECTOR’S CUT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUSPICIOUS EGGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APOLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FUCKING JUSTICE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISABELLA OF CASTILE ANSWERS HER MAIL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ZOMBIES OF MONTROSE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE CAT’S PAJAMAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20biography#biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff173f34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4TOC.vue
// module id = 72
// module chunks = 0